import React from 'react';

const SelectFilter = ({ value, onChange, options, placeholder }) => {
  return (
    <select
      className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white text-gray-700"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="" className="text-gray-500">
        {placeholder || 'Sélectionner...'}
      </option>
      {options.map((option) => (
        <option key={option.value} value={option.value} className="text-gray-700">
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default SelectFilter; 